import {SDKEventAttrs} from '@mparticle/web-sdk';
import {getPriceAmount} from '../../../shared/utils/formatPrice';
import {selectChannelData} from '../../store/slices/channel/slice';
import {ANY_EMPLOYEE} from '../../store/slices/constants';
import {
  selectServices,
  selectSkusDuration,
  selectSelectedHasDiscount,
  selectSelectedTotalPrice,
  selectSelectedOriginalPrice,
  selectSelectedEmployee,
} from '../../store/slices/selectors';
import {store} from '../../store';
import {countDaysFromCurrentDate} from '../../utils/countDaysFromCurrentDate';

export const getCheckoutClickedAttributes = () => {
  const state = store.getState();
  const channel = selectChannelData(state);
  const originalPrice = selectSelectedOriginalPrice(state);
  const selectedEmployee = selectSelectedEmployee(state);
  const isDefaultEmployee = selectedEmployee === ANY_EMPLOYEE;
  const daysFromCurrentDate = countDaysFromCurrentDate();
  const totalPrice = selectSelectedTotalPrice(state);
  const checkoutClickedAttributes: SDKEventAttrs = {
    country: channel.country.countryCode,
    platform: 'web',
    item_count: selectServices(state).length,
    selected_employee_count: isDefaultEmployee ? 0 : 1,
    is_default_employee: isDefaultEmployee,
    days_from_current_date: daysFromCurrentDate,
    total_duration: selectSkusDuration(state),
    has_discount: selectSelectedHasDiscount(state),
    total_price: getPriceAmount(totalPrice),
    currency_code: channel.currencyCode,
  };
  if (originalPrice) {
    checkoutClickedAttributes.original_price = getPriceAmount(originalPrice);
  }
  return checkoutClickedAttributes;
};
